module.exports = __webpack_public_path__ + "static/img/bg.b501197a.jpg";